import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [usage, setUsage] = useState(null);

  const refreshUsage = useCallback(async () => {
    try {
      const { data } = await api.get("/usage");
      setUsage(data);
    } catch {
      setUsage(null);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await refreshUsage();
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [refreshUsage]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const value = {
    user,
    setUser,
    loading,
    usage,
    refreshUsage,
    isAuthenticated: !!user,
    refresh: checkAuth,
    logout: async () => {
      try { await api.post("/auth/logout"); } catch {}
      setUser(null);
      setUsage(null);
    },
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
